"use strict";
var AsapAction_1 = require('./AsapAction');
var AsapScheduler_1 = require('./AsapScheduler');
exports.asap = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
//# sourceMappingURL=asap.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/scheduler/asap.js
// module id = 950
// module chunks = 3